import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useSMLRouter } from '../../../routing/sml/hooks';
import { SMLRouteNames, SMLRoutes } from '../../../routing/sml/SMLRoutes';

/**
 * The old editor opened a form on a child route: `details/widgetEdit` (a block) and `details/edit`
 * (name, address, theme). The new editor keeps that state in its own URL, so an old link lands on
 * the same place: the open row (`?block=`), the picker (`?add=1`) or the Page tab (`?tab=page`).
 */
export function useLegacyEditorRedirect(accountId: number, smartLinkId: number): void {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const router = useSMLRouter();
  const widgetUUID = searchParams.get('widgetUUID');

  useEffect(() => {
    if (pathname.includes(`/${SMLRouteNames.details}/${SMLRouteNames.widgetEdit}`)) {
      router.replace(
        SMLRoutes.details,
        widgetUUID === null ? { accountId, smartLinkId, add: '1' } : { accountId, smartLinkId, block: widgetUUID }
      );
    } else if (pathname.includes(`/${SMLRouteNames.details}/${SMLRouteNames.edit}`)) {
      router.replace(SMLRoutes.details, { accountId, smartLinkId, tab: 'page' });
    }
  }, [accountId, pathname, router, smartLinkId, widgetUUID]);
}
